import {useTranslation} from "react-i18next";
import Page from "../../common/page/Page";
import UserSearchPanel from "./UserSearchPanel";
import {UserTranslKey} from "./UserTranslKey";
import {useState} from "react";
import {UserDto} from "../../client/user/User";
import UserDetailPanel from "./detail/UserDetailPanel";
import {DetailActionButton} from "../../common/button/CommonActionButtons";

export function UserPage() {
    const [selectedUser, setSelectedUser] = useState<UserDto>();
    const [detailDialogOpen, setDetailDialogOpen] = useState(false);
    const {t} = useTranslation();

    function onDetailDialogClose() {
        setDetailDialogOpen(false)
    }

    function onUserSelected(user?: UserDto) {
        if (user?.id !== selectedUser?.id) {
            setSelectedUser(user);
        }
    }

    function showDetailDialog() {
        setDetailDialogOpen(true);
    }

    const actions: React.ReactNode = (
        <>
            <DetailActionButton onClick={showDetailDialog}
                                disabled={!selectedUser} />
        </>
    );

    return (
        <Page title={t(UserTranslKey.USER_OVERVIEW)}>
            <UserSearchPanel actions={actions}
                             onSelectedUser={onUserSelected}
                             onUserDoubleClick={showDetailDialog} />

            {selectedUser &&
                <UserDetailPanel user={selectedUser}
                                 open={detailDialogOpen}
                                 onClose={onDetailDialogClose} />
            }
        </Page>
    );
}
